import { DialogWrapper, MEDIA } from "@bridgesplit/ui";
import { useMediaQuery } from "@mui/material";
import { useAppDialog, AppDialog } from "app/utils";

import SocialShareContent from "./SocialShareContent";
import { SocialShareDialogProps } from "./types";
import { CARD_DIMS } from "./constants";

export default function SocialShareDialog() {
    const { getData } = useAppDialog();
    const data = getData(AppDialog.SocialShare) as SocialShareDialogProps;
    const cardSize = useCardSize();

    return (
        <DialogWrapper maxWidth={cardSize === "lg" ? 1132 : CARD_DIMS[cardSize].width + 32}>
            <SocialShareContent {...data} cardSize={cardSize} />
        </DialogWrapper>
    );
}

function useCardSize(): "sm" | "md" | "lg" {
    const smBreakpoint = useMediaQuery(MEDIA.MD.below);
    const mdBreakpoint = useMediaQuery(MEDIA.XXL.below);
    if (smBreakpoint) {
        return "sm";
    } else if (mdBreakpoint) {
        return "md";
    } else {
        return "lg";
    }
}
